export const backendSizeMap = {
  'square_hd': '1:1',
  'landscape_4_3': '4:3',
  'portrait_4_3': '3:4',
  'landscape_16_9': '16:9',
  'portrait_16_9': '9:16',
} as const;

export type BackendImageSize = keyof typeof backendSizeMap;

export const convertBackendSize = (backendSize: string): string => {
  // If it's a predefined size, use the map
  if (backendSize in backendSizeMap) {
    return backendSizeMap[backendSize as BackendImageSize];
  }

  return backendSize || '1:1';

  // // If it's a custom size object with width and height
  // try {
  //   const size = JSON.parse(backendSize);
  //   if (size.width && size.height) {
  //     // Simplify the ratio
  //     const gcd = (a: number, b: number): number => b ? gcd(b, a % b) : a;
  //     const divisor = gcd(size.width, size.height);
  //     return `${size.width/divisor}:${size.height/divisor}`;
  //   }
  // } catch (e) {
  //   // If parsing fails, return default ratio
  //   console.error('Error parsing image size:', e);
  // }

  // return '1:1'; // Default fallback
}; 